import _ from "lodash";
import fetch from "isomorphic-fetch";
import moment from 'moment';
import { checkHttpStatus, parseJSON } from "../utils";
import {
  SET_ALERTS,
  SET_ALERT_MESSAGE,
  UPDATING_ALERTS,
  REMOVE_ALERT_MESSAGE,
  HOMEPAGE_ALERT_SUCCESS,
  HOMEPAGE_ALERT_DISMISS
} from "../constants";

export function setAlerts(newAlerts) {
  return (dispatch, getState) => {
    dispatch({ type: UPDATING_ALERTS });
    const state = getState();
    let { data } = state.alerts;
    data = _.unionWith(data, newAlerts, _.isEqual);
    data = _.uniqBy(data, 'id');
    dispatch({
      type: SET_ALERTS,
      payload: {
        data: data
      }
    });
  };
}

export function setAlert(maintenanceAlert) {
  return (dispatch, getState) => {
    dispatch({ type: UPDATING_ALERTS });
    const state = getState();
    const { data } = state.alerts;
    if (
      _.find(data, a => {
        return a.message === maintenanceAlert.message;
      })
    )
      return;
    data.push(maintenanceAlert);
    dispatch({
      type: SET_ALERT_MESSAGE,
      payload: {
        data: data
      }
    });
  };
}

export function removeAlert(maintenanceAlert) {
  return (dispatch, getState) => {
    dispatch({ type: UPDATING_ALERTS });
    const state = getState();
    const { data } = state.alerts;
    _.remove(data, a => {
      return a.message === maintenanceAlert.message;
    });
    dispatch({
      type: REMOVE_ALERT_MESSAGE,
      payload: {
        data: data
      }
    });
  };
}

export function clearOtherCamAlerts(id) {
  return (dispatch, getState) => {
    dispatch({ type: UPDATING_ALERTS });
    const state = getState();
    const { data } = state.alerts;
    _.remove(data, a => {
      return _.get(a, "feed_id", null) && a.feed_id !== id;
    });
    dispatch({
      type: REMOVE_ALERT_MESSAGE,
      payload: {
        data: data
      }
    });
  };
}

export function homepageAlertSuccess(maintenanceAlert) {
  return {
    type: HOMEPAGE_ALERT_SUCCESS,
    payload: {
      data: maintenanceAlert
    }
  };
}

export function homepageAlertDismiss(id) {
  return {
    type: HOMEPAGE_ALERT_DISMISS,
    payload: {
      data: id
    }
  };
}

export function fetchHomepageAlerts() {
  return (dispatch, getState) => {
    return fetch(`${SERVER_URL}/get_homepage_alert`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const state = getState();
        let activeAlert = null;
        if (Array.isArray(response.data) && response.data[0]) {
          const currentlyActive = response.data.filter((alert) => {
            const notStarted = moment.utc(alert.start_date).isAfter(moment.utc());
            const hasEnded = moment.utc(alert.end_date).isBefore(moment.utc());
            const alreadyBeenDismissed = state.alerts.dismissedHomepageAlerts.includes(alert.id);
            return !(notStarted || hasEnded || alreadyBeenDismissed );
          });
          activeAlert = currentlyActive.length > 0 ? currentlyActive[0] : null;
        } else if (response.data.id) {
          activeAlert = response.data;
        }
        if (
          activeAlert &&
          !state.alerts.dismissedHomepageAlerts.find(alertId => {
            return activeAlert == alertId;
          })
        ) {
          dispatch(homepageAlertSuccess(activeAlert));
        }
      })
      .catch((error, message) => {});
  };
}
